import { Currency, DeliveryStatus, FunctionalAsset, ImageCachePaths, SpecialPrice, StockStatus } from '@synergy/models';

import { Address } from './address';
import { Attribute } from './attribute';
import { BonusCondition } from './bonus-condition';
import { Contact } from './contact';

export interface ShoppingCart {
    invoiceAddress?: Address;
    deliveryAddress?: Address;
    avisoContact?: Contact;
    desiredDeliveryDate: Date | null;
    costCentre: string;
    perOrderOrderLimit?: number;
    monthlyOrderLimit?: number;
    currentMonthlyOrderSum: number;
    suppliers: ShoppingCartSupplier[];
    itemStatuses: ShoppingCartItemStatus[];
}

export interface ShoppingCartSupplier {
    id: number;
    name: string;
    items: ShoppingCartItem[];
    image?: ImageCachePaths;
    surcharges: number;
    deliveryCosts: number;
    netTotal: number;
    termsOfDelivery?: string;
    isChargingSupplier: boolean;
    paymentTerm: string;
    conditions: BonusCondition[];
    requireFunctionalAssets: boolean;
    functionalAsset?: FunctionalAsset;
}

export interface ShoppingCartItem {
    id: number;
    product: ShoppingCartArticle;
    previewImage?: ImageCachePaths;
    quantity: number;
    netPrice: number;
    status: ShoppingCartItemStatus;
}

export enum ShoppingCartItemStatus {
    Available,
    Changed,
    Removed,
    PriceByRequest,
}

export interface ShoppingCartArticle {
    id: number;
    name: string;
    number?: string;
    globalTradeItemNumber?: string;
    orderUnit: string;
    contentUnit: string;
    contentQuantity?: number;
    deliveryStatus: DeliveryStatus;
    stockStatus: StockStatus;
    deliveryTimeInDays?: number;
    minimumOrderQuantity: number;
    maximumOrderQuantity?: number;
    quantityInterval?: number;
    isBestPrice: boolean;
    isEcoProduct: boolean;
    attributes: Attribute[];
    currency: Currency;
    mainPrice: number;
    specialPrice?: SpecialPrice;
    isFavorite: boolean;
}
